import React from 'react';
import { DataGrid } from 'devextreme-react';
import { ActionBarContext } from 'utils/ActionBarContextProvider';
import { Paper, withStyles } from '@material-ui/core';
import styles from './Transactions.styles';
import { ILinesHandle, ILinesProperties } from './Transactions.properties';
import DynamicDataGrid from 'components/common/DataGridDevEx/DynamicDataGrid';
import { columns } from './constants';
import { useRetrieveTransactionsLines } from 'api/movementEnquiry/movementEnquiry';
import { createDataSource } from 'components/common/DataGridDevEx/DataGrid.hooks';
import { BACK_BUTTON } from 'components/common/ActionBar/constants';

const Transactions = (props: ILinesProperties, ref: React.Ref<ILinesHandle>) => {
    const { classes } = props;
    const { setActionBar } = React.useContext(ActionBarContext);
    const params = new URLSearchParams(location.search);
    const ProductId = params.get('ProductId') || 0;
    const MovementId = params.get('MovementId') || 0;
    const dataGridInnerRef = React.useRef<DataGrid>();
    const fetchLinesMutation = useRetrieveTransactionsLines();

    React.useEffect(
        () => {
            setActionBar({
                leftIcons: [BACK_BUTTON],
                centerIcons: [],
                rightIcons: []
            });
        },
        []
    );

    React.useImperativeHandle(
        ref,
        () => ({}),
        []
    );

    const fetchLines = React.useCallback(
        async (BatchPage, BatchSize, Sort) => {
            if (MovementId !== undefined) {
                try {
                    const lines = await fetchLinesMutation.mutateAsync({
                        ProductId: Number(ProductId),
                        MovementId: Number(MovementId),
                        urlQueryParams: {
                            BatchPage,
                            BatchSize,
                            Sort
                        }
                    });

                    return lines?.Transactions ?? [];
                } catch (error) {
                    console.error('Error fetching lines:', error);

                    return null;
                }
            } else {
                return null;
            }
        },
        [MovementId, ProductId]
    );

    const linesDataSource = React.useMemo(
        () => createDataSource(
            'ProductId',
            { fetch: fetchLines },
        ),
        [fetchLines]
    );

    return (
        <div className={classes.parentContainer}>
            <Paper className={classes.gridContainer}>
                <DynamicDataGrid
                    dataGridClassName={classes.grid}
                    columns={columns}
                    allowHeaderFilting={false}
                    allowUpdating={false}
                    actionButtonsVisibility={false}
                    gridProps={{
                        dataSource: linesDataSource,
                        dataGridRef: dataGridInnerRef,
                        sorting: { mode: 'single' },
                        disableDrillDown: true,
                        disableEditing: true,
                        disableDelete: true,
                    }}
                />
            </Paper>
        </div>
    );
};

export default withStyles(styles, { index: 1 })(React.memo(React.forwardRef(Transactions)));
